class Hand {
    playerId;
    card1;
    card2;

    constructor(playerId, card1, card2) {
        this.playerId = playerId;
        this.card1 = card1;
        this.card2 = card2;
    }
}

export default Hand;
